import React from "react";
import { Card, CardContent, Typography, Box, Chip } from "@mui/material";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import PropTypes from "prop-types";
import AutoMode from "./AutoModeConfig";

const ConnectedDevicesCard = ({
  connectedCount,
  totalCount,
  connectedPercent,
  connectedDeviceNames = [],
  renderHeader,
  mode,
  setMode,
  handleStartCountdown,
}) => {
  return (
    <Card sx={cardStyle}>
      <CardContent sx={{ p: 1, "&:last-child": { pb: 1 }, height: "100%" }}>
        {renderHeader("Connection Status", "connected", mode)}

        {mode === "auto" ? (
          <AutoMode
            metricType="connected"
            setMode={setMode}
            onApply={(metricType, duration) => {
              // if (metricType === "connected") {

              // }
              handleStartCountdown(
                metricType,
                parseInt(duration.replace("m", ""))
              );
            }}
          />
        ) : (
          <>
            <Box sx={{ width: "100%", height: 170 }}>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={[
                      { name: "Connected", value: connectedPercent },
                      { name: "Remaining", value: 100 - connectedPercent },
                    ]}
                    dataKey="value"
                    startAngle={180}
                    endAngle={0}
                    innerRadius={60}
                    outerRadius={80}
                  >
                    <Cell fill="#22C55E" />
                    <Cell fill="#E5E7EB" />
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </Box>

            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                mt: -15,
              }}
            >
              {connectedPercent}%
            </Typography>
            <Typography
              variant="body2"
              sx={{
                textAlign: "center",
                color: "#6B7280",
                mt: 5,
              }}
            >
              {connectedCount} connected out of {totalCount} devices
            </Typography>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: 0.5,
                maxHeight: 50,
                overflowY: "auto",
              }}
            >
              {connectedDeviceNames.map((name) => {
                const isPending = name.startsWith("Pending Device");
                const shortLabel = isPending
                  ? `PD ${name.replace("Pending Device", "").trim()}`
                  : name;

                return (
                  <Chip
                    key={name}
                    label={shortLabel}
                    size="small"
                    sx={{ fontSize: "0.75rem" }}
                  />
                );
              })}
            </Box>
          </>
        )}
      </CardContent>
    </Card>
  );
};

const cardStyle = {
  borderRadius: 2,
  boxShadow: 1,
  backgroundColor: "#F9FAFB",
  width: "100%",
  minWidth: 0,
  maxWidth: 320,
  p: 1,
  height: 260,
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
};

export default ConnectedDevicesCard;

ConnectedDevicesCard.propTypes = {
  connectedCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  connectedPercent: PropTypes.number.isRequired,
  renderHeader: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
  setMode: PropTypes.func.isRequired,
  handleStartCountdown: PropTypes.func.isRequired,
  connectedDeviceNames: PropTypes.arrayOf(PropTypes.string),
};
